"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.faqMockWithoutData = exports.faqMock = void 0;
const faqMock = exports.faqMock = {
    __typename: 'EditorialFrequentlyAskedQuestions',
    id: '007c1856-faf2-4814-8723-b5144341d9f4',
    questions: [
        {
            __typename: 'EditorialFaqItem',
            title: 'FAQ question 1',
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: 'Lorem ipsum italics',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialFaqItem',
            title: 'FAQ question 2',
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: '<i>Lorem ipsum italics</i>',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '<b>Lorem ipsum bold</b>',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '{0}',
                    textLinks: [
                        {
                            relativeUrl: '/skincare',
                            title: 'Lorem ipsum relative sitecore path',
                            id: 'skincare'
                        }
                    ]
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '{0}',
                    textLinks: [
                        {
                            relativeUrl: 'https://www.youtube.com/watch?v=Putz16N_0E0&ab_channel=Jakosn',
                            title: 'Lorem ipsum absolute URL',
                            id: 'https://www.youtube.com/watch?v=Putz16N_0E0&ab_channel=Jakosn'
                        }
                    ]
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '####Lorem ipsum H4',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '#####Lorem ipsum H5',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '• Lorem ipsum bullet point',
                    textLinks: []
                }
            ]
        },
        {
            __typename: 'EditorialFaqItem',
            title: 'FAQ question 3',
            content: [
                {
                    __typename: 'EditorialBannerText',
                    text: '<i>Lorem ipsum italics</i>',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '<b>Lorem ipsum bold</b>',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '{0}',
                    textLinks: [
                        {
                            relativeUrl: '/skincare',
                            title: 'Lorem ipsum relative sitecore path',
                            id: 'skincare'
                        }
                    ]
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '{0}',
                    textLinks: [
                        {
                            relativeUrl: 'https://www.youtube.com/watch?v=Putz16N_0E0&ab_channel=Jakosn',
                            title: 'Lorem ipsum absolute URL',
                            id: 'https://www.youtube.com/watch?v=Putz16N_0E0&ab_channel=Jakosn'
                        }
                    ]
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '####Lorem ipsum H4',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '#####Lorem ipsum H5',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '',
                    textLinks: []
                },
                {
                    __typename: 'EditorialBannerText',
                    text: '• Lorem ipsum bullet point',
                    textLinks: []
                }
            ]
        }
    ]
};
const faqMockWithoutData = exports.faqMockWithoutData = {
    ...faqMock,
    questions: []
};
